import BarGraph from "./styles";
export default BarGraph;
